import { createApp } from 'vue';
import {
  Switch,
  Button,
  Layout,
  Menu,
  Breadcrumb,
  Table,
  Row,
  Col,
  Form,
  Input,
  InputNumber,
  Icon,
  Select,
  Upload,
  Tag,
  Divider,
  Checkbox,
  Radio,
  Spin,
  DatePicker,
  Pagination,
} from 'ant-design-vue';
import App from './App.vue';
import router from './router';
import store from './store';

import 'ant-design-vue/dist/antd.css';
import './assets/styles/index.css';

const { Option } = Select;

createApp(App)
  .use(store)
  .use(router)
  .use(Button)
  .use(Layout)
  .use(Breadcrumb)
  .use(Menu)
  .use(Table)
  .use(Row)
  .use(Col)
  .use(Form)
  .use(Input)
  .use(InputNumber)
  .use(Icon)
  .use(Select)
  .use(Option)
  .use(Upload)
  .use(Tag)
  .use(Divider)
  .use(Radio)
  .use(Checkbox)
  .use(Spin)
  .use(Switch)
  .use(DatePicker)
  .use(Pagination)
  .mount('#app');
